import { toastWarning } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { printApiError } from '@utils/Util';

export const getFavouriteFolders = async (params) => {
	try {
		const { data } = await ApiClient.GET('getFavouriteFolders', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const createFavouriteFolder = async (queryParam) => {
	try {
		const { data } = await ApiClient.POST('createFavouriteFolder', {}, queryParam);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getFolderListWithDetails = async (params) => {
	try {
		const { data } = await ApiClient.GET('folderList', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getFolderById = async (params) => {
	try {
		const { data } = await ApiClient.GET('getFolderById', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const deleteFavouriteFolder = async (folderId) => {
	try {
		const { data } = await ApiClient.DELETE('deleteFolder', {}, folderId);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const updateFavouriteFolder = async (queryParam) => {
	try {
		const { data } = await ApiClient.POST('updateFolder', {}, queryParam);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const addMemberToFavourite = async (folderId, memberIds) => {
	try {
		const { data } = await ApiClient.POST(
			'addMemberToFavourite',
			{},
			`/${folderId}/add-member?memberIds=${memberIds}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const removeMemberFromFavourite = async (folderId, memberId) => {
	try {
		const { data } = await ApiClient.POST(
			'removeMemberFromFavourite',
			{},
			`${folderId}/remove-member?memberIds=${memberId}`
		);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const unlinkCollection = async (collectionId, folderId) => {
	try {
		const url = `${folderId}/unlink-collection/${collectionId}`;
		const { data } = await ApiClient.POST('unlinkCollection', {}, url);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getLinkedCollections = async (folderId) => {
	try {
		const url = `${folderId}/linked-collections`;
		const { data } = await ApiClient.GET('unlinkCollection', url);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const linkCollection = async (collectionId, folderId) => {
	try {
		const url = `${folderId}/link-collection/${collectionId}`;
		const { data } = await ApiClient.POST('linkCollection', {}, url);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const addToDraft = async (designIds, folderId) => {
	try {
		const query = `?folderId=${folderId}&productIds=${designIds}`;
		const { data } = await ApiClient.POST('addToDraft', {}, query);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const removeFromDraft = async (designId, folderId) => {
	const query = `${designId}?folderId=${folderId}`;
	try {
		const { data } = await ApiClient.POST('removeFromDraft', {}, query);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getCollectionList = async (params) => {
	try {
		const { data } = await ApiClient.GET('getCollectionList', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getFavouriteSidePanelStyles = async (requestBody) => {
	try {
		const params = `?page=0&size=10`;
		const { data } = await ApiClient.POST('getManageProducts', requestBody, params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getDraftedProducts = async ({
	page,
	size,
	sortingOption,
	search,
	folderId,
	isDrafted,
	isListView
}) => {
	try {
		let params = `?page=${page}&size=${size}&sortingOption=${sortingOption}&search=${search}&folderId=${folderId}&isDrafted=${isDrafted}&isListView=${isListView}`;
		const { data } = await ApiClient.GET('getFavouriteProducts', params);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const pinAndUnPinFolder = async (folderId, isPin) => {
	try {
		const path = `${folderId}/${isPin ? 'pin' : 'unpin'}`;
		const { data } = await ApiClient.POST('pinFolder', {}, path);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const changeFolder = async (productId, newFolderId, oldFolderId) => {
	try {
		const query = `${productId}/change-folder?newFolderId=${newFolderId}&oldFolderId=${oldFolderId}`;
		const { data } = await ApiClient.POST('changeFolder', {}, query);
		return data;
	} catch (error) {
		if (error.response?.status === 400) {
			toastWarning(error.response?.data?.message);
		} else {
			printApiError(error);
		}
	}
};

export const undraftProduct = async (productId, folderId) => {
	try {
		const query = `${productId}?folderId=${folderId}`;
		const { data } = await ApiClient.POST('unlikeProduct', {}, query);
		return data;
	} catch (error) {
		printApiError(error);
	}
};
